import React from "react";
import "./DailyLimitWarning.css";
import limitsConfig from "../config/limitsConfig";

/**
 * DailyLimitWarning Component
 * Displays warning about daily post limit and data retention
 * Default limit is loaded from environment configuration
 *
 * @param {number} currentCount - Current number of posts created today
 * @param {number} limit - Daily limit (default from config: 20)
 * @param {boolean} showRetention - Show data retention warning
 */
const DailyLimitWarning = ({
  currentCount = 0,
  limit = limitsConfig.POST_PER_USER,
  showRetention = true,
}) => {
  const remaining = limit - currentCount;
  const percentage = (currentCount / limit) * 100;

  // Determine warning level
  const getWarningLevel = () => {
    if (percentage >= 100) return "critical";
    if (percentage >= 90) return "high";
    if (percentage >= 75) return "medium";
    return "low";
  };

  const warningLevel = getWarningLevel();

  // Get warning message
  const getWarningMessage = () => {
    if (currentCount >= limit) {
      return {
        icon: "🚫",
        title: "Đã đạt giới hạn hôm nay!",
        message: `Bạn đã tạo ${currentCount}/${limit} bài viết. Vui lòng quay lại sau 0h01 ngày mai.`,
        color: "#f44336",
      };
    }

    if (percentage >= 90) {
      return {
        icon: "⚠️",
        title: "Sắp đạt giới hạn!",
        message: `Bạn còn ${remaining} bài viết trong ${limit} bài/ngày.`,
        color: "#ff9800",
      };
    }

    if (percentage >= 75) {
      return {
        icon: "⏰",
        title: "Chú ý giới hạn",
        message: `Bạn đã tạo ${currentCount}/${limit} bài viết hôm nay. Còn ${remaining} bài.`,
        color: "#ffc107",
      };
    }

    return {
      icon: "✅",
      title: "Miễn phí không giới hạn!",
      message: `Bạn đã tạo ${currentCount}/${limit} bài viết hôm nay.`,
      color: "#4caf50",
    };
  };

  const warning = getWarningMessage();

  return (
    <div className={`daily-limit-warning ${warningLevel}`}>
      {/* Main Warning Card */}
      <div className="warning-card" style={{ borderLeftColor: warning.color }}>
        <div className="warning-header">
          <span className="warning-icon">{warning.icon}</span>
          <h3 className="warning-title">{warning.title}</h3>
        </div>

        <p className="warning-message">{warning.message}</p>

        {/* Progress Bar */}
        <div className="progress-container">
          <div className="progress-bar-bg">
            <div
              className="progress-bar-fill"
              style={{
                width: `${Math.min(percentage, 100)}%`,
                backgroundColor: warning.color,
              }}
            ></div>
          </div>
          <div className="progress-text">
            <span>
              {currentCount} / {limit}
            </span>
            <span>{percentage.toFixed(0)}%</span>
          </div>
        </div>

        {/* Reset Time */}
        {currentCount >= limit && (
          <div className="reset-info">
            <span className="reset-icon">🔄</span>
            <span>Giới hạn sẽ reset vào lúc 00:01 ngày mai</span>
          </div>
        )}
      </div>

      {/* Data Retention Warning */}
      {/* {showRetention && (
        <div className="retention-warning">
          <div className="retention-header">
            <span className="retention-icon">💾</span>
            <h4>Lưu trữ dữ liệu</h4>
          </div>
          <div className="retention-content">
            <div className="retention-item">
              <span className="item-icon">✅</span>
              <span>Bài viết được lưu <strong>tối đa 7 ngày</strong> trên hệ thống</span>
            </div>
            <div className="retention-item">
              <span className="item-icon">✅</span>
              <span>Sau 7 ngày sẽ tự động xóa để tiết kiệm dung lượng</span>
            </div>
            <div className="retention-item">
              <span className="item-icon">✅</span>
              <span>Thông tin tài khoản, fanpage <strong>không bao giờ bị xóa</strong></span>
            </div>
          </div>
        </div>
      )} */}

      {/* Free Tier Badge */}
      {/* <div className="free-tier-badge">
        <span className="badge-icon">🎉</span>
        <span className="badge-text">Dịch vụ hoàn toàn MIỄN PHÍ</span>
      </div> */}
    </div>
  );
};

export default DailyLimitWarning;
